import React from 'react'
import type { InterviewChoiceResource } from '@entities/api/Interview'
import { useFormContext } from 'react-hook-form'

interface Props {
  prefix: string
  itemName: string | null
  choices: InterviewChoiceResource[]
  required: boolean
}

const Single: React.FC<Props> = ({ prefix, itemName, choices, required }) => {
  const { register, watch, setValue } = useFormContext()
  const errorPrefix = `${itemName ? `${itemName}について、` : ''}`

  const inputName = `${prefix}.value`
  const value = watch(inputName)

  const handleChangeRadio = (event) => {
    setValue(inputName, event.target.value)
  }

  return (
    <div className="row" data-toggle="buttons">
      <input
        ref={register({
          required: required && `${errorPrefix}1つ選択してください`,
        })}
        type="hidden"
        name={inputName}
      />
      {choices.map((choice, index) => {
        const id = `${prefix}_${choice.id}`
        const selected = choice.body === value
        return (
          <div
            key={id}
            className={`col-sm-6 ${index % 2 === 0 ? 'pr-sm-2' : 'pl-sm-2'} mb-3 form-group btn-group-toggle`}
          >
            <label
              id={id}
              className={`btn btn-light btn-block h-100 form-control ${selected ? 'active' : ''}`}
            >
              <input
                type="radio"
                id={id}
                value={choice.body}
                defaultChecked={selected}
                className="btn-check"
                onClick={handleChangeRadio}
              />
              <div>{choice.body}</div>
            </label>
          </div>
        )
      })}
    </div>
  )
}

export default Single
